module.exports = __webpack_public_path__ + "img/STAR SHADES GREEN.dbfcb54.svg";